import React from 'react';

import { Container } from './styles';

const Grid: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default Grid;
